import { Button, Input, Popconfirm, Select, Space, message } from 'antd'
import React from 'react'
import { View } from 'styles/reactnative'
import API from '../../../utils/api'
import { useToken } from '../../hooks'

const OVManage = ({ data, mutate }: any) => {
	const { data: token } = useToken()
	const addPairs = async () => {
		if (!data?.ep_id) {
			API.post('/admin/pairs', token + '', {
				ov: data?.symbol,
			}).then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate();
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
		} else {
			message.error('이미 등록된 종목입니다.')
		}
	}
	const deletePairs = async () => {
		if (data?.ep_id) {
			API.delete('/admin/pairs', token + '', {
				ov: data?.symbol,
			}).then(res => {
				if (res.result.success) {
					message.success('성공')
					mutate();
				} else {
					message.error(res?.result?.message || '실패')
				}
			})
		} else {
			message.error('이미 삭제된 종목입니다.')
		}
	}

	return (
		<Space.Compact>
			{data?.ep_id ? (
				<Button
					type={'primary'}
					size='small'
					danger
					onClick={() => {
						deletePairs()
					}}>
					거래종목 제거
				</Button>
			) : (
				<Button
					type={'primary'}
					size='small'
					onClick={() => {
						addPairs()
					}}>
					거래종목 추가
				</Button>
			)}
		</Space.Compact>
	)
}

export default React.memo(OVManage)
